<template>
    <div class="wrap">
        <listHeader
            :title="postData.sid > 0 ? '编辑学校' : '新增学校'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="school"
                active="info"
                :sid="postData.sid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="学校名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入学校名称" v-decorator="['sname', {rules: [{ required: true, max: 64, message: '请输入学校名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="用户名"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="用户名（填写后更新用户名）" v-decorator="['username', {rules: [{ required: false, max: 32, message: '请输入用户名' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'schoolCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'sid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/school/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.sid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            sname: res.data.sname,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.sid > 0) {
                            url = '/manage/school/edit';
                            values.sid = this.postData.sid;
                        } else {
                            url = '/manage/school/save';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
